// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HUtzF","colBig":"styles_colBig__1jYwY","colSmall":"styles_colSmall__3J6DA"};